<template>
    <div>
        <template v-if="is_loading_ev_scroing">
            <div class="font-italic">
                (불러오는 중)
            </div>
        </template>
        <template v-else>
            <div v-if="!ev_scoring_list?.length" class="border-0">
                평가요소가 없습니다
            </div>
            <div v-else>
                <a-i-evaluation-component-v2 v-show="show_ai_assessment"
                                             :ev_scoring_list="ev_scoring_list"
                                             :sub_id="sub_id"
                                             :sub_label="sub_label"
                                             :sub_code="sub_code"
                                             @handleChange="handleChange()"
                />
                <user-evaluation-component-v2 v-show="!show_ai_assessment"
                                              :ev_scoring_list="ev_scoring_list"
                                              :sub_code="sub_code"
                                              :disabled="disabled"
                                              :is_print="is_print"
                                              :ev_results="ev_results"
                                              :is_updating_ev_scoring="is_updating_ev_scoring"
                                              :is_not_applicable="is_not_applicable"
                                              @resetEvaluation="resetEvaluation"
                                              @handleChange="handleChange()"
                />
            </div>

            <template v-if="temp_review.auditor_name">
                <div class="f-90 gray-500 fw-300">
                    {{ temp_review.auditor_name ? 'Audited :' : '' }} {{ temp_review.auditor_name }}
                    {{ temp_review.time_stamp }}
                </div>
            </template>

            <!-- 인쇄물에는 입력란/버튼 없이 작성된 의견만 읽기 전용으로 싣는다 -->
            <div v-if="is_print && temp_review.review_comment" class="f-90 mb-2" style="white-space: pre-wrap">{{ temp_review.review_comment }}</div>
            <div v-else-if="is_reviews_loaded && !is_print">
                <b-overlay :show="show_ai_assessment">
                    <b-form-textarea v-model="temp_review.review_comment"
                                     :class="[temp_review.auditor_name ? 'bg-blue2 border-white' : 'border border-color-gray-600 border-width-1p8', 'mb-2']"
                                     placeholder="현장에서 확인한 사항을 작성하여 주십시오."
                                     :rows="6" max-rows="60"
                                     :disabled="is_updating_ev_scoring || is_updating_ev_review || is_not_applicable === null || disabled"
                    >
                    </b-form-textarea>

                    <template v-if="is_not_applicable === null">
                        <div class="f-90 text-light bg-danger rounded p-2 mb-2">
                            업체 답변과 평가자 판정의 <b>"해당없음"</b>이 서로 달라 이 문항의 점수를 계산할 수 없습니다. 문항 단위로 해당없음/해당있음 처리하거나 초기화해 주세요.
                        </div>
                    </template>

                    <div class="d-flex justify-content-between">
                        <div>
                            <template v-if="!isFieldEmpty(ev_scoring_list)">
                                <!-- 문항 단위 버튼은 해당없음이 섞인 상태(null)에서도 눌러야 풀 수 있다 -->
                                <b-button size="sm" class="mr-2"
                                          :variant="is_not_applicable === true ? 'dark' : 'dark-border'"
                                          :disabled="is_updating_ev_scoring || is_updating_ev_review || is_not_applicable === true"
                                          @click="saveSubNotApplicable(true)"
                                >
                                    해당없음 처리
                                </b-button>
                                <b-button size="sm" class="mr-2" variant="dark-border"
                                          :disabled="is_updating_ev_scoring || is_updating_ev_review || is_not_applicable === false"
                                          @click="saveSubNotApplicable(false)"
                                >
                                    해당있음 처리
                                </b-button>
                                <b-btn size="sm" :variant="is_not_applicable === true ? 'danger' : 'outline-danger'"
                                       :disabled="is_updating_ev_scoring || is_updating_ev_review || !is_evs_audited"
                                       @click="resetSubsvaluations"
                                >
                                    전체 초기화
                                </b-btn>
                            </template>
                        </div>


                        <b-button class="ml-auto"
                                  :variant="is_updating_ev_scoring || disabled ? 'mode' : 'blue'"
                                  size="sm"
                                  :disabled="is_updating_ev_scoring || is_updating_ev_review || is_not_applicable === null || disabled"
                                  @click="saveReviewComments"
                        >
                            저장하기
                        </b-button>
                    </div>
                    <template #overlay>
                        <div class="text-center gray-600">
                            {{ $t('AI 평가 보기 모드에서는 사용하실 수 없습니다.') }}
                        </div>
                    </template>
                </b-overlay>

            </div>
        </template>
    </div>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex';
import UserEvaluationComponentV2 from '@/components/evaluations/UserEvaluationComponent_v2.vue';
import AIEvaluationComponentV2 from '@/components/evaluations/AIEvaluationComponent_v2.vue';

export default {
    name: 'EvaluationComponentV2',
    components: {AIEvaluationComponentV2, UserEvaluationComponentV2},
    props: {
        sub_code: {
            type: String,
            default: null,
        },
        sub_label: {
            type: [String, null],
            default: null,
        },
        sub_id: {
            type: [Number, null],
            default: null
        },
        sub_description: {
            type: String
        },
        disabled: {
            type: Boolean,
            default: false
        },
        show_ai_assessment: {
            type: Boolean,
            default: false
        },
        is_print: {
            type: Boolean,
            default: false,
        },
        ev_results: {
            type: Object,
            default: () => ({}),
        },
        ev_list: {
            type: Object,
            default: () => ({}),
        },
        question_contents: {
            type: Array,
            default: () => ([]),  
        }
    },
    data() {
        return {
            temp_review: {
                sub_code: '',
                auditor_name: '',
                review_comment: '',
                task_comment: '',
                time_stamp: '',
            },
            save_state: 'not_saved',
            validation_comment: '',
            validation_icon: '',
            validation_style: '',
            ev_scoring_list: [],
            is_loading_ev_scroing: false,
            is_updating_ev_scoring: false,
            is_updating_ev_review: false,
        };
    },
    computed: {
        ...mapState('reviews', {
            reviews: state => state.reviews,
            review_campaign_id: state => state.campaign_id,
            is_reviews_loaded: state => state.is_reviews_loaded,
            is_review_saved: state => state.is_review_saved
        }),
        ...mapState(['question_composition']),
        ...mapState('score', ['is_evaluate_loaded', 'is_comment_loaded', 'evaluate_results']),
        ...mapState('questions', ['subs', 'subs_loaded', 'answer_company']),
        ...mapState('industry_scores', ['is_qe_evaluate_loaded']),
        ...mapState('evaluations', ['ev_code_list', 'evaluation_list']),
        user_name() {
            return this.$store.state.user_name;
        },
        campaign() {
            return this.$store.state.campaign;
        },
        question_name() {
            return this.$store.state.question_composition.question_name;
        },
        question_code() {
            return this.$store.state.question_composition.question_code;
        },
        is_not_applicable() {
            const ev_not_applicable_list = this.ev_scoring_list.map(item => item.ev_result.not_applicable);
            if (ev_not_applicable_list.every(ev_not_applicable => ev_not_applicable == true)) return true;
            if (ev_not_applicable_list.every(ev_not_applicable => ev_not_applicable == false)) return false;

            // //어떠한 오류로 인해 같은 sub 내의 evaluation.not_applicable이 모두 동일한 값이지 않을 때,
            // throw Error(`Not all 'not_applicable' values are the same within the group in ${this.sub_code}`)
            return null;
        },
        sub_ev_result() {
            return this.ev_results?.[this.sub_code];
        },
        sub_display_name() {
            return this.sub_label || this.sub_code;
        },
        is_evs_audited() {
            return this.ev_scoring_list.some(({ev_result}) => ev_result.judged_by === 'audit');
        }
    },
    watch: {
        save_state(newValue) {
            if (newValue == 'saving') {
                this.validation_comment = '저장 중 입니다.';
                this.validation_icon = 'hourglass';
                this.validation_style = 'ih-validation-saving';
            } else if (newValue == 'saved') {
                this.validation_comment = '저장 되어있습니다';
                this.validation_icon = 'check';
                this.validation_style = 'ih-validation-saved';
            } else if (newValue == 'resaved') {
                this.validation_comment = '변경 저장 되었습니다';
                this.validation_icon = 'check';
                this.validation_style = 'ih-validation-resaved';
            }
        },
        subs_loaded: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.initiateTempReview();
                }
            }
        },
        // 문항별로 감시한다: 다른 문항 저장으로 부모가 그 문항 결과만 교체해도 이 문항의 미저장 입력이 서버값으로 덮이지 않는다
        sub_ev_result: {
            deep: true,
            immediate: true,
            handler() {
                this.transformEVData(this.ev_results);
            }
        },
        reviews: {
            deep: true,
            handler() {
                // 다른 문항의 의견 저장으로 스토어가 갱신돼도 이 문항에서 작성 중인 의견은 덮어쓰지 않는다
                if (this.isTempReviewDirty()) return;
                this.initiateTempReview();
            }
        }
    },
    created() {
        this.transformEVData();
        this.$emit('evaluation-load-finished', this.sub_code);
    },
    beforeDestroy() {
        this.update_qe_evaluate_result_loaded(false);
    },
    methods: {
        ...mapMutations('industry_scores', ['update_qe_evaluate_result_loaded']),
        ...mapActions('industry_scores', ['readQeEvaluateResult', 'saveQeEvaluateResult']),
        ...mapActions('reviews', ['initiateReviews', 'saveSubReview']),
        ...mapActions('evaluations', ['setAuditCategory', 'fetchEvResults', 'fetchCategory3Aggr']),
        transformEVData(_ev_item = this.ev_item) {
            if (_ev_item?.[this.sub_code] == null) return;
            const sub_ev_results = _ev_item[this.sub_code].ev_results;
            this.ev_scoring_list = [...sub_ev_results].reduce((_ev_scoring_list, ev_scoring) => {
                let target_ev_info = null;
                if(this.is_print) {
                    target_ev_info = this.ev_list[this.sub_code]?.find(ev => ev.ev_id === ev_scoring.ev_id) || {};
                }
                else {
                    target_ev_info = this.evaluation_list[this.sub_code]?.find(ev => ev.ev_id === ev_scoring.ev_id) || {};
                }

                _ev_scoring_list.push({
                    ev_info: target_ev_info,
                    ev_result: {
                        audit_category_code: null,
                        audit_comment: ev_scoring.comment || '',
                        ...ev_scoring,
                    }
                });

                return _ev_scoring_list;
            }, []);
        },
        async handleChange() {
            this.is_updating_ev_scoring = true;
            await this.evaluationSave();
            this.is_updating_ev_scoring = false;
        },
        async evaluationSave() {
            try {
                const saving_ev_list = [...this.ev_scoring_list].reduce((_saving_evs, {ev_result}, idx) => {
                    const prev_ev_result = this.ev_results[this.sub_code].ev_results.find(e => e.ev_id === ev_result.ev_id) || {};
                    
                    const form = {
                        ev_id: ev_result.ev_id,
                        target_company_id: this.answer_company.company_id,
                        author_id: this.$store.state.user_id,
                        audit_category_code: ev_result.audit_category_code,
                        comment: ev_result.audit_comment,
                        not_applicable: ev_result.not_applicable,
                        satisfied: ev_result.satisfied,
                        // AI 평가 적용으로 회차 id 가 찍힌 경우에만 payload 에 포함한다.
                        // 값이 없는데 키를 넣으면 백엔드 UPDATE 가 "키 존재"만으로 기존
                        // ai_audit_id 를 NULL 로 덮어써 학습 링크가 파괴되므로 조건부로 넣는다.
                        ...(ev_result.ai_audit_id != null ? { ai_audit_id: ev_result.ai_audit_id } : {}),
                    };

                    if (
                        (
                            (ev_result.satisfied !== prev_ev_result.satisfied)
                            ||
                            (ev_result.satisfied !== null && ev_result.satisfied !== prev_ev_result.satisfied)
                        )
                        ||
                        (
                            (ev_result.not_applicable !== prev_ev_result.not_applicable)
                            ||
                            (ev_result.not_applicable !== null && ev_result.not_applicable !== prev_ev_result.not_applicable)
                        )
                    ) {
                        _saving_evs.push(form);
                    }
                    else if (ev_result.audit_category_code !== prev_ev_result.audit_category_code) {
                        if(ev_result.audit_category_code != null || prev_ev_result.audit_category_code != null){
                            _saving_evs.push(form);
                        }                     
                    }
                    else if (ev_result.audit_comment !== prev_ev_result.comment) {
                        if (ev_result.audit_comment !== '' || prev_ev_result.comment != null) {
                            form.comment = !ev_result.audit_comment || !ev_result.audit_comment.trim() ? null : ev_result.audit_comment.trim();
                            _saving_evs.push(form);
                        }
                    }
                    // satisfied/not_applicable/category/comment 가 모두 동일해도, AI 적용으로
                    // ai_audit_id 가 새로 찍혔으면(기존 NULL → 회차 id) 저장 대상에 포함한다.
                    else if ((ev_result.ai_audit_id ?? null) !== (prev_ev_result.ai_audit_id ?? null)) {
                        _saving_evs.push(form);
                    }

                    return _saving_evs;
                }, []);

                const {pc, project_code, cmp, campaign_id, cpn, company_id} = this.$route.query;

                const _campaign_id = cmp ?? campaign_id;
                const _company_id = cpn ?? company_id;
                const _project_code = pc ?? project_code;

                await this.saveQeEvaluateResult({
                    project_code: _project_code,
                    campaign_id: Number(_campaign_id),
                    company_id: Number(_company_id),
                    sub_code: this.sub_code,
                    ev_list: saving_ev_list,
                    from_v3: true
                });

                await this.resetSubResult();
            } catch (error) {
                alert('죄송합니다. Evaluation 저장 도중 장애가 발생했습니다. 페이지 데이터를 다시 호출하겠습니다.');
                this.$emit('reset-sub-evaluation');
            }
        },
        async resetSubResult(question = this.question_composition) {
            const {mapEv} = await this.fetchEvResults({
                campaign_id: Number(this.answer_company.campaign_id),
                company_id: Number(this.answer_company.company_id),
                sub_code: question.question_contents,
            });
            // 부모의 ev_results 가 '이전 값' 비교 기준이므로 저장 결과로 이 문항 항목을 교체한다
            if (mapEv?.[this.sub_code] != null) this.$emit('ev-results-updated', this.sub_code, mapEv[this.sub_code]);
            this.$forceUpdate();
        },
        async resetEvaluation(i) {
            const ev_name = this.ev_scoring_list[i].ev_info.name || this.ev_scoring_list[i].ev_info.ev_id;
            const confirmed = await this.$showModal({
                type: 'confirm',
                state: 'error',
                title: '평가요소 초기화',
                message: `${this.sub_display_name} 문항의 평가요소 "${ev_name}"에 평가자가 입력한 판정과 의견이 삭제되고 기계평가 값으로 돌아갑니다. 되돌릴 수 없습니다. 계속하시겠습니까?`,
            });
            if (!confirmed) return;
            this.is_updating_ev_scoring = true;
            const reqBody = {
                campaign_id: Number(this.$route.query.cmp),
                company_id: Number(this.$route.query.cpn),
                ev_id: this.ev_scoring_list[i].ev_info.ev_id,
            };

            try {
                await this.$axios.delete('/evaluation/audit', {data: reqBody});
                await this.resetSubResult();
            } catch (error) {
                this.$EventBus.$emit('toast-failure', '평가요소 초기화 실패', `${this.sub_display_name} 문항의 평가요소를 초기화하지 못했습니다. 잠시 후 다시 시도해 주세요.`);
            } finally {
                this.is_updating_ev_scoring = false;
            }
        },
        routeTarget() {
            const {pc, project_code, cmp, campaign_id, cpn, company_id} = this.$route.query;
            return {
                project_code: pc ?? project_code,
                campaign_id: Number(cmp ?? campaign_id),
                company_id: Number(cpn ?? company_id),
            };
        },
        // 해당없음은 문항 단위 개념이라 평가요소 전부를 한 요청으로 바꾼다 (satisfied 는 백엔드가 전부 false 로 덮음).
        // 평가요소마다 저장하면 중간 상태에서 값이 섞여 점수 산출이 422 로 멈춘다 (backend #1986).
        async saveSubNotApplicable(not_applicable) {
            if (not_applicable) {
                const confirmed = await this.$showModal({
                    type: 'confirm',
                    state: 'warning',
                    title: '해당없음 처리',
                    message: `${this.sub_display_name} 문항의 평가요소 ${this.ev_scoring_list.length}개가 모두 해당없음으로 저장되고 입력한 충족 여부는 사라집니다. 되돌리려면 "전체 초기화"를 사용해야 합니다. 계속하시겠습니까?`,
                });
                if (!confirmed) return;
            } else {
                const h = this.$createElement;
                const confirmed = await this.$showModal({
                    type: 'confirm',
                    state: 'warning',
                    title: '해당있음 처리',
                    message: h('div', {}, [
                        h('div', {}, '이 문항의 모든 평가요소가 미충족으로 초기화됩니다. 계속하시겠습니까?'),
                        h('div', {class: 'text-muted small mt-2'},
                            '업체가 정상 답변한 문항에서 평가자의 해당없음 처리를 되돌리려면 "전체 초기화"를 사용해 주세요. 기계평가 결과로 돌아갑니다.'),
                    ]),
                });
                if (!confirmed) return;
            }
            const {project_code, campaign_id, company_id} = this.routeTarget();
            try {
                this.is_updating_ev_scoring = true;
                await this.$axios.put('/evaluation/audit/not-applicable', {
                    campaign_id, company_id, sub_code: this.sub_code, not_applicable,
                });
            } catch (error) {
                alert(error?.response?.status === 409
                    ? '같은 문항이 동시에 저장됐습니다. 다시 시도해 주세요.'
                    : `죄송합니다. ${this.sub_code} 문항의 해당${not_applicable ? '없음' : '있음'} 처리 도중 장애가 발생했습니다. 개발팀에 문의해주세요.`);
            } finally {
                this.afterSubLevelChange(project_code, company_id);
            }
        },
        // 평가요소별 DELETE 를 병렬로 부르면 지울 때마다 중간 상태가 섞여 422 로 실패한다 → 문항 단위로 한 번에 삭제.
        async resetSubsvaluations() {
            const confirmed = await this.$showModal({
                type: 'confirm',
                state: 'error',
                title: '평가 전체 초기화',
                message: `${this.sub_display_name} (${this.sub_code}) 문항의 평가요소 ${this.ev_scoring_list.length}개에 대한 평가자 판정과 의견이 모두 삭제되고 기계평가 결과로 돌아갑니다. 되돌릴 수 없습니다. 계속하시겠습니까?`,
            });
            if (!confirmed) return;
            const {project_code, campaign_id, company_id} = this.routeTarget();
            try {
                this.is_updating_ev_scoring = true;
                await this.$axios.post('/evaluation/audit/by-sub-codes', {
                    company_id, campaign_id, sub_codes: [this.sub_code], confirm: true,
                });
            } catch (error) {
                alert(`죄송합니다. ${this.sub_code} 문항의 평가 전체 초기화 도중 장애가 발생했습니다. 개발팀에 문의해주세요.`);
            } finally {
                this.afterSubLevelChange(project_code, company_id);
            }
        },
        afterSubLevelChange(project_code, company_id) {
            this.$emit('reset-sub-evaluation');
            // 페이지 상단의 문항 수준·점수 요약 422 안내가 이전 상태로 남지 않게 다시 조회 (실패는 스토어가 삼킨다)
            this.fetchCategory3Aggr({project_code, company_id});
            this.is_updating_ev_scoring = false;
        },
        findReviewObj(company_id, sub_code) {
            let idx = this.reviews.findIndex(item => item.company_id == company_id);
            if (this.is_reviews_loaded) {
                if (idx > -1) {
                    let temp_rev = this.reviews[idx].review_results;
                    let review_idx = temp_rev.findIndex(review_item => review_item.sub_code == sub_code);
                    if (review_idx > -1) {
                        return this.reviews[idx].review_results[review_idx];
                    }
                }
            }

            return undefined;
        },
        isTempReviewDirty() {
            const stored = this.findReviewObj(this.answer_company.company_id, this.sub_code)?.review_comment;
            return (this.temp_review.review_comment || '').trim() !== (stored || '').trim();
        },
        initiateTempReview() {
            this.is_updating_ev_review = true;
            let temp_rev = this.findReviewObj(this.answer_company.company_id, this.sub_code);
            let review_obj = {};
            if (typeof temp_rev != 'undefined') {
                review_obj = {
                    sub_code: temp_rev.sub_code,
                    auditor_name: temp_rev.auditor_name,
                    review_comment: temp_rev.review_comment,
                    task_comment: temp_rev.task_comment,
                    time_stamp: temp_rev.time_stamp
                };
            } else {
                review_obj = {
                    sub_code: this.sub_code,
                    auditor_name: '',
                    review_comment: '',
                    task_comment: '',
                    time_stamp: '',
                };
            }

            this.temp_review = review_obj;
            this.is_updating_ev_review = false;
        },
        async saveReviewComments() {
            this.is_updating_ev_review = true;
            const {cmp, cpn, campaign_id, company_id} = this.$route.query;
            let review_obj = {
                campaign_id: cmp ?? campaign_id,
                company_id: cpn ?? company_id,
                sub_code: this.sub_code
            };

            if (this.temp_review?.review_comment?.trim()) {
                review_obj.auditor_name = this.user_name;
                review_obj.review_comment = this.temp_review.review_comment;
                review_obj.task_comment = this.temp_review.task_comment;
            } else {
                review_obj.auditor_name = null;
                review_obj.review_comment = null;
                review_obj.task_comment = null;
            }

            try {
                await this.saveSubReview(review_obj);
                this.$EventBus.$emit('toast-success', '의견 저장', `${this.sub_display_name} 문항의 의견을 저장했습니다.`);
            } catch (error) {
                this.$EventBus.$emit('toast-failure', '의견 저장 실패', '저장하지 못했습니다. 입력한 내용은 그대로 남아 있으니 다시 시도해 주세요.');
            } finally {
                this.is_updating_ev_review = false;
            }
        },
    }
};
</script>

<style>

</style>
